import React from "react";
import {
  HeadingCostWrapper,
  MainContainer,
  ProductCost,
  ProductHeading,
  ProductInfoWrapper,
  StyledImage,
  InnerContainer,
  StyledQuantity,
  StyledNumberInput,
  RemoveButton,
} from "./styles";
import CrossIcon from "@/assets/icons/crossIcon";

const ProductLineItems = ({ cartItem, onRemove, onQuantityChange }) => {
  const handleQuantityChange = (value) => {
    onQuantityChange(cartItem.productId, value);
  };

  return (
    <MainContainer>
      <InnerContainer>
        <ProductInfoWrapper>
          {cartItem?.productImage ? (<StyledImage
            src={cartItem?.productImage}
            alt={cartItem?.productName || "Product Image"}
          />) : (
            <div
              style={{
                width: 50,
                height: 50,
                background: "#f5f5f5",
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 11,
                color: "#999",
                flexShrink: 0,
              }}
            >
              No Image
            </div>
          )}
          {/* item?.variantPrice && item.variantPrice !== 0 ? Number(item.variantPrice) : Number(item.productPrice) */}
          <HeadingCostWrapper>
            <ProductHeading>{cartItem?.productName}</ProductHeading>
            <ProductCost>{`Product Cost : $${cartItem?.variantPrice && cartItem?.variantPrice !== 0
              ? cartItem?.variantPrice
              : cartItem?.productPrice
              }`}</ProductCost>
          </HeadingCostWrapper>
          <StyledQuantity>
            <div>
              <StyledNumberInput
                min={1}
                size="medium"
                value={cartItem?.productQuantity}
                onChange={handleQuantityChange}
              />
            </div>
            <RemoveButton
              type="button"
              aria-label="Remove item"
              onClick={() => onRemove(cartItem?.productId)}
            >
              <CrossIcon />
            </RemoveButton>
          </StyledQuantity>
        </ProductInfoWrapper>
      </InnerContainer>
    </MainContainer>
  );
};

export default ProductLineItems;
